module.exports = __webpack_public_path__ + "img/choose-up-1_1_text.8db0b37c.png";